import { Injectable } from '@angular/core';

import { RegisterPayload } from '@modules/core/interfaces';
import { SignUpResponseDTO } from '@paymash/sdk/dto/response';
import { SignUpRequestDTO } from '@paymash/sdk/dto/request';
import { Customer, Auth } from '@models';

@Injectable({
  providedIn: 'root',
})
export class SignUpMapper {
  public mapToCustomerEntity(dto: SignUpResponseDTO): Customer {
    return {
      firstName: dto.customer.firstName,
      lastName: dto.customer.lastName,
      email: dto.customer.email,
      phone: dto.customer.phone,
      salutation: dto.customer.salutation,
    };
  }

  public mapToAuthEntity(dto: SignUpResponseDTO): Auth {
    return {
      accessToken: dto.access.accessToken,
      refreshToken: dto.access.refreshToken,
    };
  }

  public mapToDTO(entity: RegisterPayload): SignUpRequestDTO {
    return {
      firstName: entity.firstName,
      lastName: entity.lastName,
      email: entity.email,
      phone: entity.phone,
      salutation: entity.salutation,
      password: entity.password,
    };
  }
}
